import * as yup from 'yup';


import validationService from '../../ValidationService';


yup.addMethod(yup.string, 'phoneNumber', function (options) {

    return this.test('phoneNumber', 'phone.error', function (number) {

        const {createError, path} = this;
        const {message} = options || {};

        const num = (number || '').trim();
        if (!num.match(/^\d+$/g)) {

            return createError({
                message: message || 'i18n:phone.form.field.number.error.invalid-chars',
                path
            });
        }

        return true;
    });
});


yup.addMethod(yup.object, 'phone', function (options) {

    return this.test('phone', 'phone.error', async function (phone, context) {

        const {createError, path} = this;
        const {message} = options || {};

        // only remote-validate if callingCode and countryAlpha2 are set also
        if (
            !phone.callingCode
            || !phone.countryAlpha2
            || !phone.number
            || phone.number.length < 5
        ) {

            return true;
        }

        const isPhoneValid = await validationService.validatePhone(phone);

        if (!isPhoneValid) {

            return createError({
                message: message || 'i18n:phone.form.field.phone.error.invalid',
                path: path || 'phone' // using number as field
            });
        }

        return true;
    });
});

